import script from "./FormulaContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormulaContent.vue?vue&type=script&lang=ts&setup=true"

import "./FormulaContent.vue?vue&type=style&index=0&id=1c41d9fe&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c41d9fe"]])

export default __exports__